export const showGeneratedPdfBox = (bool) => ({
  type: 'SHOW_GENERATED_PDF_BOX',
  bool
})
